import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";
import Modal from "react-bootstrap/Modal";
import { AnchorComponent, ButtonComponent } from "../elements";

export default function TrainingTableComponent({ thead, tbody }) {
  const { t } = useContext(TranslatorContext);

  const [alertModal, setAlertModal] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const [data, setData] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    setData(tbody);
  }, [tbody]);

  /* =========================
     EDIT HANDLER
  ========================== */
  const handleEdit = (item) => {
    setSelectedItem({ ...item });
    setEditModal(true);
  };

  /* =========================
     UPDATE HANDLER
  ========================== */
  const handleUpdate = () => {
    const updatedData = data.map((item) =>
      item.id === selectedItem.id ? selectedItem : item
    );

    setData(updatedData);
    setEditModal(false);
  };

  return (
    <div className="mc-table-responsive">
      <table className="mc-table product">
        <thead className="mc-table-head primary">
          <tr>
            {thead.map((item, index) => (
              <th key={index}>{t(item)}</th>
            ))}
          </tr>
        </thead>

        <tbody className="mc-table-body even">
          {data?.map((item, index) => (
            <tr key={index}>
              <td>{item.f_number}</td>
              <td>{item.children_name}</td>
              <td>{item.institute_name}</td>
              <td>{item.training_name}</td>
              <td>{item.training_duration}</td>
              <td>{item.total_fees}</td>
              <td>{item.status}</td>

              {/* <td>
                <div className="mc-table-action">
                 
                  <ButtonComponent
                    type="button"
                    className="material-icons edit"
                    onClick={() => handleEdit(item)}
                  >
                    edit
                  </ButtonComponent>

                
                  <ButtonComponent
                    type="button"
                    className="material-icons delete"
                    onClick={() => setAlertModal(true)}
                  >
                    delete
                  </ButtonComponent>
                </div>
              </td> */}
            </tr>
          ))}
        </tbody>
      </table>

      {/* ======================
          EDIT MODAL
      ======================= */}
      <Modal show={editModal} onHide={() => setEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Training</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="form-group mb-3">
            <label>Institute Name</label>
            <input
              type="text"
              className="form-control"
              value={selectedItem?.institute_name || ""}
              onChange={(e) =>
                setSelectedItem({
                  ...selectedItem,
                  institute_name: e.target.value,
                })
              }
            />
          </div>

          <div className="form-group mb-3">
            <label>Training Name</label>
            <input
              type="text"
              className="form-control"
              value={selectedItem?.training_name || ""}
              onChange={(e) =>
                setSelectedItem({
                  ...selectedItem,
                  training_name: e.target.value,
                })
              }
            />
          </div>

          <div className="form-group mb-3">
            <label>Duration</label>
            <input
              type="text"
              className="form-control"
              value={selectedItem?.training_duration || ""}
              onChange={(e) =>
                setSelectedItem({
                  ...selectedItem,
                  training_duration: e.target.value,
                })
              }
            />
          </div>

          <div className="form-group mb-3">
            <label>Total Fees</label>
            <input
              type="number"
              className="form-control"
              value={selectedItem?.total_fees || ""}
              onChange={(e) =>
                setSelectedItem({
                  ...selectedItem,
                  total_fees: e.target.value,
                })
              }
            />
          </div>

          <div className="form-group mb-3">
            <label>Status</label>
            <select
              className="form-control"
              value={selectedItem?.status || ""}
              onChange={(e) =>
                setSelectedItem({
                  ...selectedItem,
                  status: e.target.value,
                })
              }
            >
              <option value="pending">Pending</option>
              <option value="completed">Completed</option>
            </select>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <ButtonComponent
            type="button"
            className="btn btn-secondary"
            onClick={() => setEditModal(false)}
          >
            {t("close")}
          </ButtonComponent>

          <ButtonComponent
            type="button"
            className="btn btn-primary"
            onClick={handleUpdate}
          >
            {t("update")}
          </ButtonComponent>
        </Modal.Footer>
      </Modal>

      {/* ======================
          DELETE MODAL
      ======================= */}
      <Modal show={alertModal} onHide={() => setAlertModal(false)}>
        <div className="mc-alert-modal">
          <i className="material-icons">new_releases</i>
          <h3>Are you sure?</h3>
          <p>Want to delete this training?</p>

          <Modal.Footer>
            <ButtonComponent
              type="button"
              className="btn btn-secondary"
              onClick={() => setAlertModal(false)}
            >
              {t("close")}
            </ButtonComponent>

            <ButtonComponent
              type="button"
              className="btn btn-danger"
              onClick={() => setAlertModal(false)}
            >
              {t("delete")}
            </ButtonComponent>
          </Modal.Footer>
        </div>
      </Modal>
    </div>
  );
}
